import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';
import FieldModel from './form_field';

export default class FormEntry extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static list(apiList, language) {
        return apiList.map(item => this.fromJSON(item, language));
    }

    toAPI() {
        let entry = this.form_field;
        let content = super.toAPI();
        if (!entry) {
            return content;
        }
        if (entry instanceof FieldModel) {
            content.form_field = entry.toAPI();
        }
        return content;
    }

    static fromJSON(entry, language = null) {
        const item_instance = new this(entry);
        item_instance.form_field = FieldModel.fromJSON(entry.form_field, language);
        return item_instance;
    }

    static listUrl() {
        throw new ArgumentError(`[Model][Field][getAll] Need to implement some static methods before`);
    }
}
